<template>
    <div class="form-group col-12">
        <div class="row">
            <div class="form-group col-md-4 col-sm-6">
                <label for="title">Title</label>
                <input
                    id="title"
                    v-model="content.title"
                    :class="{
                        'is-invalid': v.title.$error
                    }"
                    class="form-control"
                    dir="auto"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({})
        },
        v: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            content: {}
        };
    },

    watch: {
        content() {
            this.$emit('input', this.content);
        }
    },

    mounted() {
        this.content = { ...this.value };
    }
};
</script>
